import { Dispatch } from 'react';
import { PricingApi } from '../../../api/api.apiclient';
import {
  DELETE_ITEM_PRICE,
  DeleteItemPriceAction,
  GET_ITEM_PRICE,
  GET_ITEM_PRICE_LIST,
  POST_ITEM_PRICE,
  PUT_ITEM_PRICE, UPDATE_ITEM_PRICE_FILTERS,
  UpdateItemPriceFiltersAction
} from '../types/itemprice.types';
import { ItemPriceFilters, ItemPriceRequest } from '../../../api/pricing/pricing.types';
import { PageRequest } from '../../../api/api.types';

export const getItemPriceList = (filters?: ItemPriceFilters, page?: PageRequest) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.ItemPrices.listAllItemPrices(filters, page);

  dispatch({
    type: GET_ITEM_PRICE_LIST,
    payload: {
      page: response.data
    }
  });
};

export const getItemPrice = (id: number) => async (dispatch: Dispatch<any>) => {
  try {
    const response = await PricingApi.ItemPrices.getOneItemPrice(id);

    dispatch({
      type: GET_ITEM_PRICE,
      payload: {
        selectedItemPrice: response.data
      }
    });
  } catch (e) {
    dispatch({
      type: GET_ITEM_PRICE,
      payload: {
        selectedItemPrice: null
      }
    });
  }
};

export const addNewItemPrice = (request: ItemPriceRequest) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.ItemPrices.addNewItemPrice(request);

  dispatch({
    type: POST_ITEM_PRICE,
    payload: {
      success: true,
      newItemPrice: response.data
    }
  });
};

export const deleteItemPrice = (id: number) => async (dispatch: Dispatch<DeleteItemPriceAction>) => {
  await PricingApi.ItemPrices.deleteItemPrice(id);
  dispatch({
    type: DELETE_ITEM_PRICE,
    payload: {
      success: true
    }
  });
};

export const editItemPrice = (id: number, request: ItemPriceRequest) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.ItemPrices.editItemPrice(id, request);

  dispatch({
    type: PUT_ITEM_PRICE,
    payload: {
      selectedItemPrice: response.data
    }
  });
};

export const updateItemPriceFilters = (filters: ItemPriceFilters) => async (dispatch: Dispatch<UpdateItemPriceFiltersAction>) => {
  dispatch({
    type: UPDATE_ITEM_PRICE_FILTERS,
    payload: {
      filters: filters
    }
  });
};
